import validate from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+node@22.20.2_@vue+compil_imtilspo6mr4i272bnxju3emwy/node_modules/nuxt/dist/pages/runtime/validate.js";
import device_45global from "/nuxtWeb/middleware/device.global.ts";
import legacy_45user_45center_45redirect_45global from "/nuxtWeb/middleware/legacy-user-center-redirect.global.ts";
import user_45center_45auth_45global from "/nuxtWeb/middleware/user-center-auth.global.ts";
import manifest_45route_45rule from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+node@22.20.2_@vue+compil_imtilspo6mr4i272bnxju3emwy/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  device_45global,
  legacy_45user_45center_45redirect_45global,
  user_45center_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}